import { ExcelColumnsDataInitialValue } from '@/types/app/excelColumnData';
import ProductExcelInterface from '@/types/app/productsExcel';

export default {
  productsToExcel: new Array<ProductExcelInterface>(),
  isSavingFile: false,
  columns: ExcelColumnsDataInitialValue,
  isExportingFile: false
};
